import { onSnapshot } from "firebase/firestore";

// Simplified Firebase Optimizer - Only Essential Features
class FirebaseOptimizer {
  constructor() {
    this.cache = new Map();
    this.cacheDuration = 5 * 60 * 1000; // 5 minutes
    this.activeListeners = new Map();
  }

  // Simple cache check
  getCachedData(key) {
    const cached = this.cache.get(key);
    if (cached && Date.now() - cached.timestamp < this.cacheDuration) {
      return cached.data;
    }
    return null;
  }

  // Simple cache set
  setCachedData(key, data) {
    this.cache.set(key, { data, timestamp: Date.now() });
  }

  // Get cache timestamp
  getCacheTimestamp(key) {
    const cached = this.cache.get(key);
    return cached ? cached.timestamp : null;
  }

  // Set cache timestamp
  setCacheTimestamp(key, timestamp) {
    const cached = this.cache.get(key);
    if (cached) {
      this.cache.set(key, { data: cached.data, timestamp });
    }
  }

  // Clear cache
  clearCache(key) {
    this.cache.delete(key);
  }

  // Track Firebase read (simplified)
  trackRead(count) {
    // Simplified - no complex stats
  }

  // Connection management
  getListener(key, query, callback) {
    // Remove existing listener if any
    if (this.activeListeners.has(key)) {
      this.activeListeners.get(key)();
      this.activeListeners.delete(key);
    }

    // Create new listener
    const unsubscribe = onSnapshot(query, callback);
    this.activeListeners.set(key, unsubscribe);
    return unsubscribe;
  }
}

// Simple tab visibility check
export const isTabVisible = () => !document.hidden;

// Export singleton
export const firebaseOptimizer = new FirebaseOptimizer();
